export type StatusEnum =
    'not_existing'
    | 'created'
    | 'sending'
    | 'sending_successful'
    | 'sending_confirmed'
    | 'sending_error'
    | 'sending_finalized';

export const StatusEnum = {
    NotExisting: 'not_existing' as StatusEnum,
    Created: 'created' as StatusEnum,
    Sending: 'sending' as StatusEnum,
    SendingSuccessful: 'sending_successful' as StatusEnum,
    SendingConfirmed: 'sending_confirmed' as StatusEnum,
    SendingError: 'sending_error' as StatusEnum,
    SendingFinalized: 'sending_finalized' as StatusEnum
};

